export default {
  'Account not found': 'Compte non-identifié',
} as const;
